import { TrianglePointIcon } from '@/assets/icons/TrianglePointIcon';
import { Link } from '@/ui-components/atoms/Link/Link';
import { Text } from '@/ui-components/atoms/Text/Text';
import styles from './snapshotpopover.module.scss';

export type SnapshotAlertBannerTone = 'critical' | 'warning';

export interface SnapshotAlertBannerProps {
    ctaHref?: string;
    ctaLabel: string;
    message: string;
    tone: SnapshotAlertBannerTone;
}

function WarningCircleIcon(): React.JSX.Element {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="10" cy="10" r="8.75" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M10.5 12.5H9.5L9 9V5H11V9L10.5 12.5Z" fill="currentColor" />
            <path d="M9 14H11V16H9V14Z" fill="currentColor" />
        </svg>
    );
}

export function SnapshotAlertBanner({
    ctaHref,
    ctaLabel,
    message,
    tone,
}: SnapshotAlertBannerProps): React.JSX.Element {
    return (
        <div className={styles.snapshotAlertBannerWrapper}>
            <div className={styles.snapshotAlertBanner} data-tone={tone}>
                <div className={styles.snapshotAlertBannerIcon} data-tone={tone}>
                    {tone === 'critical' ? <TrianglePointIcon /> : <WarningCircleIcon />}
                </div>
                <div className={styles.snapshotAlertBannerContent}>
                    <Text tag="p" className={styles.snapshotAlertBannerMessage} data-tone={tone}>
                        {message}
                    </Text>
                    <div className={styles.snapshotAlertBannerActions}>
                        <Link className={styles.snapshotAlertItemLink} href={ctaHref || '#'}>
                            {ctaLabel}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
